import { getApiEndpoints } from "../config/AuthConfigContext";
import { getStoredTokenData } from "./memberManagementService";

export interface UpdateProfilePayload {
  id: string;
  FirstName?: string;
  LastName?: string;
  ProfilePicUrl?: string;
}

export interface UpdateProfileResponse {
  success: boolean;
  message?: string;
  data?: any;
}

export const updateProfile = async (
  payload: UpdateProfilePayload,
): Promise<UpdateProfileResponse> => {
  try {
    const token = getStoredTokenData()?.token;

    if (!token) {
      throw new Error("Bearer token not available");
    }

    const endpoints = getApiEndpoints();

    const response = await fetch(endpoints.UPDATE_PROFILE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      return {
        success: false,
        message: errorData?.detail || response.statusText,
      };
    }

    const responseData = await response.json();

    return {
      success: true,
      data: responseData,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
};
